import './src/styles/global.css';

export const onInitialClientRender = () => {
  const loadAdSense = () => {
    if (document.querySelector('script[src*="adsbygoogle"]')) return;
    const script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src =
      'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6158243498318454';
    document.head.appendChild(script);
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadAdSense, { timeout: 3000 });
  } else {
    setTimeout(loadAdSense, 3000);
  }
};
